import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import * as S from './styles';

type Props = {
  children: React.ReactNode;
  placeholder?: React.ReactNode;
  onLoad: () => void;
  contentIndex: number;
  rootMargin?: '50px';
};

const InfiniteScroll = ({
  children,
  placeholder,
  onLoad,
  contentIndex,
  rootMargin,
}: Props) => {
  const [ref, inView] = useInView({ rootMargin });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (inView && !isLoading) {
      onLoad();
      setIsLoading(true);
    }
  }, [onLoad, inView, isLoading]);

  // When contentIndex changes, we want to reset the isLoading state, but only in the next
  // animation frame in order to give the new content a chance to render before we decide
  // to load more content.
  useEffect(() => {
    requestAnimationFrame(() => setIsLoading(false));
  }, [contentIndex]);

  return (
    <S.InfiniteScroll>
      {children}
      <div ref={ref}>{placeholder || null}</div>
    </S.InfiniteScroll>
  );
};

export default InfiniteScroll;
